import Breadcrumbs from '@mui/material/Breadcrumbs';
import { FoldersActions } from "actions";
import { useHistory, useParams } from "react-router-dom";
import { BreadCrumbs } from "components";
import { icons } from "constants/viewer";
import { getFileIcon } from "actions/GlobalActions";
import { useStyles } from "panels/CheckboxList";
import { Public, Folder } from "@mui/icons-material";
import { ReactComponent as File } from "assets/images/file.svg";
import commonStyles from "styles/common";
import "styles/Pathfinder.css";

function getIcon(entity: any, classes: any) {
    var fileName = getFileIcon(entity);
    //console.log("fileName:", fileName);
    if (!fileName) {
        return { kind: "svg", file: File };
    }
    const iconSrc = icons[fileName];
    return { kind: "image", file: iconSrc };
}

export default function Pathfinder() {
    const { classes: common } = commonStyles();
    const { classes, cx} = useStyles();
    
    const history = useHistory();
    var { catalogId } = useParams();
    var catalog = FoldersActions.getCatalog(catalogId);
    const path = FoldersActions.getPath(catalog);
    const setCatalogId = (catalog: string) => {
        if (catalog === "0") {
            history.push("/catalog");
        } else {
            history.push("/catalog/" + catalog);
        }
    };
    //const mainTitle = path[path.length - 1].name !== 'Root' ? path[path.length - 1].name : 'My Projects';
    const mainTitle = path.length > 0 && path[path.length - 1].name && path[path.length - 1].name !== 'Root' ? path[path.length - 1].name : 'My Projects';
    return (
        <div className={cx(common.middle)} style={{alignItems: 'start', justifyContent: 'space-between', width: '100%', flexDirection: 'column'}}>
            <BreadCrumbs label={mainTitle} className='mainTitle' />

            <Breadcrumbs
                classes={{ ol: 'list-none m-0 p-0' }}
                aria-label="breadcrumb"
                color="primary"
            >
            <BreadCrumbs image={Public} label="My Projects" onClick={(evt: any) => setCatalogId("0")} hidden={mainTitle === 'My Projects'} />
            {path.map((folder: any, index: number) => {
                var entityType = folder.file_type === "FOLDER" ? "folders" : "entities";
                return folder.name !== "Root" ? (
                    <BreadCrumbs
                        key={"path-" + index}
                        label={folder.name}
                        {...( index < path.length - 1 ? {onClick: (evt: any) => setCatalogId(folder.ID)} : {})}
                        hideArrow={index < path.length - 1 ? false : true}
                        image={entityType === "folders" ? Folder : getIcon(folder, classes)}
                    />
                ) : (
                    ""
                );
            })}
            </Breadcrumbs>
        </div>
    );
}
